/**
 * PageNotFound Component
 * A React component that displays a 404 error page when a route is not found
 * Provides a user-friendly error message and a link to return to the home page
 */

import React from "react";
import { Link } from "react-router-dom";

/**
 * 404 error page component
 * Displays a centered error message with navigation back to home
 * @returns {JSX.Element} Rendered 404 error page
 */
const PageNotFound = () => {
  /**
   * Component render section
   * Renders a full-screen centered layout with error message and home link
   */
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-4xl text-center font-bold mb-4">
        404 - Pagina Non Trovata
      </h1>
      <p className="mb-6">Sembra che la pagina che stai cercando non esista.</p>
      <Link to="/" className="text-blue-500 hover:underline">
        Torna alla Home
      </Link>
    </div>
  );
};

export default PageNotFound;
